import { useCallback, useEffect, useRef, useState } from "react";

import { copyToClipboard } from "@/components/hooks/useClipboardCallback";
import { notify } from "@/components/shared/AppToast";
import { t } from "@/localization";

// Copy with feedback where the user clicked (the button or icon turns into a
// check for a moment) and a short toast at the bottom of the screen.
//   const { copy, isCopied } = useCopy();
//   copy(value, "link", { toast: "Link copied", detail: value })
// `value` may be a function returning the text (or a promise of it) for links
// fetched on demand. Only do that on iOS/Android: on the web, pass the text so
// the copy happens inside the click (browsers refuse it after an await).
export default function useCopy({ resetMs = 1800 } = {}) {
  const [copiedKey, setCopiedKey] = useState(null);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(
    async (value, key = "default", { toast = t("Copied"), detail } = {}) => {
      const text = typeof value === "function" ? await value() : value;
      await copyToClipboard(text);
      setCopiedKey(key);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopiedKey(null), resetMs);
      if (toast) notify.success(toast, detail);
    },
    [resetMs]
  );

  const isCopied = useCallback(
    (key = "default") => copiedKey === key,
    [copiedKey]
  );
  return { copy, isCopied };
}
